import { useDemoTheme } from './DemoThemeContext';
import { QTYPES } from '../../data/demoQuestions';
import MCQQuestion from './MCQQuestion';
import GridQuestion from './GridQuestion';
import CodingQuestion from './CodingQuestion';
import FileUploadQuestion from './FileUploadQuestion';

export default function QuestionArea({ question, answer, onAnswer }) {
  const { isDark } = useDemoTheme();
  if (!question) return null;

  const renderInput = () => {
    switch (question.type) {
      case QTYPES.MCQ:    return <MCQQuestion question={question} selectedAnswer={answer || null} onAnswer={onAnswer} />;
      case QTYPES.GRID:   return <GridQuestion question={question} gridAnswers={answer || {}} onGridChange={(id, val) => onAnswer(id, val)} />;
      case QTYPES.CODING: return <CodingQuestion question={question} codeAnswer={answer || null} onCodeChange={(id, val) => onAnswer(id, val)} />;
      case QTYPES.FILE:   return <FileUploadQuestion question={question} fileAnswer={answer || null} onFileChange={(id, val) => onAnswer(id, val)} />;
      default: return null;
    }
  };

  return (
    <div className="h-full flex flex-col" data-testid="question-area">
      <div className="flex-1 overflow-y-auto px-8 py-7 space-y-6">
        {/* Body text + code blocks */}
        <div>
          <pre className="whitespace-pre-wrap text-sm leading-relaxed font-sans" style={{ color: 'var(--d-text-hi)', fontFamily: 'inherit' }}>
            {question.body.split(/(```[\s\S]*?```)/g).map((part, i) => {
              if (part.startsWith('```')) {
                const lines = part.split('\n');
                const lang = lines[0].replace('```', '').trim();
                const code = lines.slice(1, -1).join('\n');
                return (
                  <code key={i} className="block rounded-xl p-5 my-3 text-xs leading-relaxed overflow-x-auto"
                    style={{ background: 'var(--d-code-bg)', border: '1px solid var(--d-border)', color: 'var(--d-code-text)', fontFamily: "'JetBrains Mono','Fira Code',monospace" }}>
                    {lang && <div className="text-xs mb-3 pb-2" style={{ color: 'var(--d-text-3)', borderBottom: '1px solid var(--d-border-sub)' }}>{lang}</div>}
                    {code}
                  </code>
                );
              }
              return (
                <span key={i}>
                  {part.split(/(`[^`]+`)/g).map((chunk, j) => {
                    if (chunk.startsWith('`') && chunk.endsWith('`')) {
                      return (
                        <code key={j} className="px-1.5 py-0.5 rounded text-xs font-mono"
                          style={{ background: 'rgba(124,58,237,0.12)', color: 'var(--d-code-text)', border: '1px solid rgba(124,58,237,0.2)' }}>
                          {chunk.slice(1, -1)}
                        </code>
                      );
                    }
                    return <span key={j}>{chunk}</span>;
                  })}
                </span>
              );
            })}
          </pre>
        </div>
        <div>{renderInput()}</div>
      </div>
    </div>
  );
}
